// extracted by mini-css-extract-plugin
export default {"container":"AdminUserCard_container__q1paM","nameWrap":"AdminUserCard_nameWrap__J-F39","resume":"AdminUserCard_resume__ZsEDr","status":"AdminUserCard_status__XGsY8"};